/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Off_SuccessInputs */

const es_chat_branch_off_success = /** @type {(inputs: Chat_Branch_Off_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bifurcación creada`)
};

const en_chat_branch_off_success = /** @type {(inputs: Chat_Branch_Off_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch created`)
};

/**
* | output |
* | --- |
* | "Branch created" |
*
* @param {Chat_Branch_Off_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_branch_off_success = /** @type {((inputs?: Chat_Branch_Off_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Off_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_branch_off_success(inputs)
	return en_chat_branch_off_success(inputs)
});
export { chat_branch_off_success as "chat.branch_off.success" }